<template>
    <div class="Bgc-white">
            <div class="content">
                <div class="reservaciones">
                        <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ title }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ body }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeExpiredModal"
                aria-label="Close modal">
          {{ button }}
        </button>
      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->
                </div>
            </div>
    </div>
</template>
<script>

import * as GlobalFunctions from "./../../utils/GlobalFunctions";
import Modal from '../../components/addons/Modal'
import i18n from '../../plugins/i18n';
import SecureLS from 'secure-ls';

export default {
    name: 'ExpirationModal',
    components: {
        Modal
    },
    data() {
        return {
            isExpiredModalVisible: true,
            title: "Sesión expirada",
            body: "Tu sesión ha expirado. Por favor ingresa nuevamente.",
            button: "Entendido"
        }
    },
    methods: {
        closeExpiredModal() {
                this.isExpiredModalVisible = false
                let ls = new SecureLS({encodingType: 'aes'});
                GlobalFunctions.localStorageClean();
                this.$router.push({ name: "Login" });
        }
    },
    created() {
       let ls = new SecureLS({encodingType: 'aes'});
       if (ls.get('Language').data == "en") {
           this.title = "Expired Session"
           this.body = "Your session has expired. Please login again."
           this.button = "Understood"
       }
    }
}
</script>

<style lang="scss" scoped>
    .reservaciones {
        width: 100%;
    }
</style>